import T from '@wojtekmaj/react-t';

import LinkButton from '@rewardopl/react-ui/link_button';

import { ContentWrapper, Image, PageWrapper, Sub, Title } from './index.styles';

import RewardoLogo from '../../common/rewardo_logo';

import { SHOULD_DISABLE_REGISTER_PAGE } from '../../../constants';

import padlockIcon from '../../../static/padlock.svg';

type NoAccessPageProps = {
  state?: object;
};

export default function NoAccessPage({ state }: NoAccessPageProps) {
  return (
    <PageWrapper>
      <ContentWrapper>
        <RewardoLogo width={164} />
        <Image alt="" height={124} src={padlockIcon} width={124} />
        <Title>
          <T>No access</T>
        </Title>
        <Sub>
          <T>This page is for logged in users only.</T>
        </Sub>
        <p>
          <LinkButton className="primary" state={state} to="/login">
            <T>Login</T>
          </LinkButton>
        </p>
        {SHOULD_DISABLE_REGISTER_PAGE ? null : (
          <p>
            <LinkButton state={state} to="/register">
              <T>Register</T>
            </LinkButton>
          </p>
        )}
      </ContentWrapper>
    </PageWrapper>
  );
}
